module.exports = __webpack_public_path__ + "static/assets/1641962d47544abbb5416073c4a9b639.png";